/*** IMPORTS FROM imports-loader ***/
var define = false;

/**
 * Symbimed API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.2
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.2.3
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ArrayResponse', 'model/DataResponse', 'model/ErrorResponse', 'model/InlineResponse200', 'model/InlineResponse2001', 'model/MessageResponse', 'model/Params', 'model/Params1', 'model/Params2', 'model/Params3', 'model/Params4', 'model/Params5', 'model/Report', 'model/Status', 'model/User'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ArrayResponse'), require('../model/DataResponse'), require('../model/ErrorResponse'), require('../model/InlineResponse200'), require('../model/InlineResponse2001'), require('../model/MessageResponse'), require('../model/Params'), require('../model/Params1'), require('../model/Params2'), require('../model/Params3'), require('../model/Params4'), require('../model/Params5'), require('../model/Report'), require('../model/Status'), require('../model/User'));
  } else {
    // Browser globals (root is window)
    if (!root.SymbimedApi) {
      root.SymbimedApi = {};
    }
    root.SymbimedApi.DefaultApi = factory(root.SymbimedApi.ApiClient, root.SymbimedApi.ArrayResponse, root.SymbimedApi.DataResponse, root.SymbimedApi.ErrorResponse, root.SymbimedApi.InlineResponse200, root.SymbimedApi.InlineResponse2001, root.SymbimedApi.MessageResponse, root.SymbimedApi.Params, root.SymbimedApi.Params1, root.SymbimedApi.Params2, root.SymbimedApi.Params3, root.SymbimedApi.Params4, root.SymbimedApi.Params5, root.SymbimedApi.Report, root.SymbimedApi.Status, root.SymbimedApi.User);
  }
}(this, function(ApiClient, ArrayResponse, DataResponse, ErrorResponse, InlineResponse200, InlineResponse2001, MessageResponse, Params, Params1, Params2, Params3, Params4, Params5, Report, Status, User) {
  'use strict';

  /**
   * Default service.
   * @module api/DefaultApi
   * @version 0.2
   */

  /**
   * Constructs a new DefaultApi. 
   * @alias module:api/DefaultApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the createStatus operation.
     * @callback module:api/DefaultApi~createStatusCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DataResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a new status from the provided data
     * @param {module:model/Params5} params 
     * @param {module:api/DefaultApi~createStatusCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DataResponse}
     */
    this.createStatus = function(params, callback) {
      var postBody = params;

      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling createStatus");
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['isDoctor'];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = DataResponse;

      return this.apiClient.callApi(
        '/status', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the findDoctorByName operation.
     * @callback module:api/DefaultApi~findDoctorByNameCallback
     * @param {String} error Error message, if any.
     * @param {module:model/User} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns a doctor by name
     * @param {String} name Query doctor name
     * @param {module:api/DefaultApi~findDoctorByNameCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/User}
     */
    this.findDoctorByName = function(name, callback) {
      var postBody = null;

      // verify the required parameter 'name' is set
      if (name === undefined || name === null) {
        throw new Error("Missing the required parameter 'name' when calling findDoctorByName");
      }


      var pathParams = {
      };
      var queryParams = {
        'name': name
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = User;

      return this.apiClient.callApi(
        '/public/doctor', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forgottenPassword operation.
     * @callback module:api/DefaultApi~forgottenPasswordCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MessageResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Forgotten password reset
     * @param {module:model/Params1} params 
     * @param {module:api/DefaultApi~forgottenPasswordCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MessageResponse}
     */
    this.forgottenPassword = function(params, callback) {
      var postBody = params;

      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling forgottenPassword");
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = MessageResponse;

      return this.apiClient.callApi(
        '/forgot', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getAirDetails operation.
     * @callback module:api/DefaultApi~getAirDetailsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ArrayResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get latest air pollution and pollen data by city name
     * @param {String} cityName Name of a city
     * @param {module:api/DefaultApi~getAirDetailsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ArrayResponse}
     */
    this.getAirDetails = function(cityName, callback) {
      var postBody = null;

      // verify the required parameter 'cityName' is set
      if (cityName === undefined || cityName === null) {
        throw new Error("Missing the required parameter 'cityName' when calling getAirDetails");
      }


      var pathParams = {
        'cityName': cityName
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['isDoctor'];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = ArrayResponse;

      return this.apiClient.callApi(
        '/weather/air/{cityName}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getConfig operation.
     * @callback module:api/DefaultApi~getConfigCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DataResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns every survey config
     * @param {Object} opts Optional parameters
     * @param {String} opts.lang 
     * @param {module:api/DefaultApi~getConfigCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DataResponse}
     */
    this.getConfig = function(opts, callback) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'lang': opts['lang']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = DataResponse;

      return this.apiClient.callApi(
        '/survey/config', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getConsultingConfig operation.
     * @callback module:api/DefaultApi~getConsultingConfigCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DataResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets the consulting config of the logged in doctor
     * @param {module:api/DefaultApi~getConsultingConfigCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DataResponse}
     */
    this.getConsultingConfig = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['isDoctor'];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = DataResponse;

      return this.apiClient.callApi(
        '/consulting/config', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getData operation.
     * @callback module:api/DefaultApi~getDataCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DataResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets a formatted health data for a patient
     * @param {Object} opts Optional parameters
     * @param {String} opts.patientId 
     * @param {String} opts.period 
     * @param {module:api/DefaultApi~getDataCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DataResponse}
     */
    this.getData = function(opts, callback) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'patientId': opts['patientId'],
        'period': opts['period']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['isLoggedIn'];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = DataResponse;

      return this.apiClient.callApi(
        '/patient/health/data', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getDoctorById operation.
     * @callback module:api/DefaultApi~getDoctorByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/User} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get full data of a doctor
     * @param {String} id ID of a doctor
     * @param {module:api/DefaultApi~getDoctorByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/User}
     */
    this.getDoctorById = function(id, callback) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getDoctorById");
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = User;

      return this.apiClient.callApi(
        '/doctor/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getFeed operation.
     * @callback module:api/DefaultApi~getFeedCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/Status>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get status feed for public users, personalised feed if the user is a patient, created posts for doctors and admins (not done yet)
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.userCreated 
     * @param {Number} opts.limit 
     * @param {Number} opts.skip 
     * @param {String} opts.since 
     * @param {module:api/DefaultApi~getFeedCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/Status>}
     */
    this.getFeed = function(opts, callback) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'userCreated': opts['userCreated'],
        'limit': opts['limit'],
        'skip': opts['skip'],
        'since': opts['since']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = [Status];

      return this.apiClient.callApi(
        '/status', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getGlobalInfo operation.
     * @callback module:api/DefaultApi~getGlobalInfoCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DataResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Return global information about the patients
     * @param {module:api/DefaultApi~getGlobalInfoCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DataResponse}
     */
    this.getGlobalInfo = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['isDoctor'];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = DataResponse;

      return this.apiClient.callApi(
        '/doctor/global', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getGlobalReport operation.
     * @callback module:api/DefaultApi~getGlobalReportCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DataResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Generates a pdf report for a given date about the coming patients
     * @param {Object} opts Optional parameters
     * @param {String} opts.languageId 
     * @param {module:api/DefaultApi~getGlobalReportCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DataResponse}
     */
    this.getGlobalReport = function(opts, callback) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'languageId': opts['languageId']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['isDoctor'];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = DataResponse;

      return this.apiClient.callApi(
        '/doctor/report/pdf', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getGlobalSymptoms operation.
     * @callback module:api/DefaultApi~getGlobalSymptomsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DataResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns symptoms of every patient of the current doctor (used for global symptom graph)
     * @param {module:api/DefaultApi~getGlobalSymptomsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DataResponse}
     */
    this.getGlobalSymptoms = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['isDoctor'];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = DataResponse;

      return this.apiClient.callApi(
        '/doctor/symptoms', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getInfo operation.
     * @callback module:api/DefaultApi~getInfoCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DataResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns general information about the server, eg. the current build number
     * @param {module:api/DefaultApi~getInfoCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DataResponse}
     */
    this.getInfo = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = DataResponse;

      return this.apiClient.callApi(
        '/info', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getPatientList operation.
     * @callback module:api/DefaultApi~getPatientListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/User>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns the patients of the logged in doctor
     * @param {Object} opts Optional parameters
     * @param {String} opts.order 
     * @param {Boolean} opts.asc 
     * @param {Number} opts.skip 
     * @param {Number} opts.limit 
     * @param {String} opts.emailPrefix 
     * @param {module:api/DefaultApi~getPatientListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/User>}
     */
    this.getPatientList = function(opts, callback) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'order': opts['order'],
        'asc': opts['asc'],
        'skip': opts['skip'],
        'limit': opts['limit'],
        'emailPrefix': opts['emailPrefix']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['isDoctor'];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = [User];

      return this.apiClient.callApi(
        '/doctor/patients', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getRecords operation.
     * @callback module:api/DefaultApi~getRecordsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DataResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets medical records of the user
     * @param {module:api/DefaultApi~getRecordsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DataResponse}
     */
    this.getRecords = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['isLoggedIn'];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = DataResponse;

      return this.apiClient.callApi(
        '/patient/record', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getReport operation.
     * @callback module:api/DefaultApi~getReportCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Report} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets a formatted health report for a patient since the last consultation
     * @param {Object} opts Optional parameters
     * @param {String} opts.patientId 
     * @param {Date} opts.fromDate 
     * @param {Date} opts.toDate 
     * @param {module:api/DefaultApi~getReportCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Report}
     */
    this.getReport = function(opts, callback) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'patientId': opts['patientId'],
        'fromDate': opts['fromDate'],
        'toDate': opts['toDate']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['isLoggedIn'];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = Report;

      return this.apiClient.callApi(
        '/patient/health/report', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getStatusById operation.
     * @callback module:api/DefaultApi~getStatusByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Status} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get details of a status by a supplied id
     * @param {String} id ID of a status
     * @param {module:api/DefaultApi~getStatusByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Status}
     */
    this.getStatusById = function(id, callback) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getStatusById");
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['isLoggedIn'];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = Status;

      return this.apiClient.callApi(
        '/status/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the invitationRequest operation.
     * @callback module:api/DefaultApi~invitationRequestCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DataResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Posts an invitation request from a patient with doctor details
     * @param {Object} opts Optional parameters
     * @param {String} opts.name 
     * @param {String} opts.email 
     * @param {String} opts.phone 
     * @param {String} opts.website 
     * @param {module:api/DefaultApi~invitationRequestCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DataResponse}
     */
    this.invitationRequest = function(opts, callback) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
        'name': opts['name'],
        'email': opts['email'],
        'phone': opts['phone'],
        'website': opts['website']
      };

      var authNames = [];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = DataResponse;

      return this.apiClient.callApi(
        '/patient/invite', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the listDoctors operation.
     * @callback module:api/DefaultApi~listDoctorsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/User>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns public doctor list
     * @param {module:api/DefaultApi~listDoctorsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/User>}
     */
    this.listDoctors = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = [User];

      return this.apiClient.callApi(
        '/public/doctors', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the login operation.
     * @callback module:api/DefaultApi~loginCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MessageResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * login
     * @param {module:model/Params} params 
     * @param {module:api/DefaultApi~loginCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MessageResponse}
     */
    this.login = function(params, callback) {
      var postBody = params;

      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling login");
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = MessageResponse;

      return this.apiClient.callApi(
        '/login', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the logout operation.
     * @callback module:api/DefaultApi~logoutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MessageResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * logout
     * @param {module:api/DefaultApi~logoutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MessageResponse}
     */
    this.logout = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['isLoggedIn'];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = MessageResponse;

      return this.apiClient.callApi(
        '/logout', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the patientPdfReport operation.
     * @callback module:api/DefaultApi~patientPdfReportCallback
     * @param {String} error Error message, if any.
     * @param {File} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Generates a pdf report for a patient or the current user
     * @param {Object} opts Optional parameters
     * @param {String} opts.patientId 
     * @param {String} opts.languageId 
     * @param {module:api/DefaultApi~patientPdfReportCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link File}
     */
    this.patientPdfReport = function(opts, callback) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'patientId': opts['patientId'],
        'languageId': opts['languageId']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['isValidated'];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = File;

      return this.apiClient.callApi(
        '/patient/health/pdf', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the postNotification operation.
     * @callback module:api/DefaultApi~postNotificationCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MessageResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Post a manual notification by the logged in doctor
     * @param {module:model/Params4} params 
     * @param {module:api/DefaultApi~postNotificationCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MessageResponse}
     */
    this.postNotification = function(params, callback) {
      var postBody = params;

      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling postNotification");
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['isDoctor'];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = MessageResponse;

      return this.apiClient.callApi(
        '/doctor/notify', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the postSurvey operation.
     * @callback module:api/DefaultApi~postSurveyCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DataResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Expects a health survey from the logged in user
     * @param {Boolean} symptom 
     * @param {module:api/DefaultApi~postSurveyCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DataResponse}
     */
    this.postSurvey = function(symptom, callback) {
      var postBody = null;

      // verify the required parameter 'symptom' is set
      if (symptom === undefined || symptom === null) {
        throw new Error("Missing the required parameter 'symptom' when calling postSurvey");
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
        'symptom': symptom
      };

      var authNames = ['isLoggedIn'];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = DataResponse;

      return this.apiClient.callApi(
        '/survey', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profile operation.
     * @callback module:api/DefaultApi~profileCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse200} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns user data if logged in
     * @param {module:api/DefaultApi~profileCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse200}
     */
    this.profile = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['isLoggedIn'];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = InlineResponse200;

      return this.apiClient.callApi(
        '/profile', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the requestAnalyze operation.
     * @callback module:api/DefaultApi~requestAnalyzeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DataResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Submits a medical record image
     * @param {File} image 
     * @param {module:api/DefaultApi~requestAnalyzeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DataResponse}
     */
    this.requestAnalyze = function(image, callback) {
      var postBody = null;

      // verify the required parameter 'image' is set
      if (image === undefined || image === null) {
        throw new Error("Missing the required parameter 'image' when calling requestAnalyze");
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
        'image': image
      };

      var authNames = ['isLoggedIn'];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = DataResponse;

      return this.apiClient.callApi(
        '/patient/record', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the resetPassword operation.
     * @callback module:api/DefaultApi~resetPasswordCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MessageResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Resets the supplied users password, based on the token
     * @param {module:model/Params2} params 
     * @param {module:api/DefaultApi~resetPasswordCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MessageResponse}
     */
    this.resetPassword = function(params, callback) {
      var postBody = params;

      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling resetPassword");
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = MessageResponse;

      return this.apiClient.callApi(
        '/reset', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the setConsultingConfig operation.
     * @callback module:api/DefaultApi~setConsultingConfigCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DataResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the consulting config of the logged in doctor
     * @param {String} day 
     * @param {String} location 
     * @param {Number} fromTime 
     * @param {Number} toTime 
     * @param {Object} opts Optional parameters
     * @param {String} opts.comment 
     * @param {module:api/DefaultApi~setConsultingConfigCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DataResponse}
     */
    this.setConsultingConfig = function(day, location, fromTime, toTime, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'day' is set
      if (day === undefined || day === null) {
        throw new Error("Missing the required parameter 'day' when calling setConsultingConfig");
      }

      // verify the required parameter 'location' is set
      if (location === undefined || location === null) {
        throw new Error("Missing the required parameter 'location' when calling setConsultingConfig");
      }

      // verify the required parameter 'fromTime' is set
      if (fromTime === undefined || fromTime === null) {
        throw new Error("Missing the required parameter 'fromTime' when calling setConsultingConfig");
      }

      // verify the required parameter 'toTime' is set
      if (toTime === undefined || toTime === null) {
        throw new Error("Missing the required parameter 'toTime' when calling setConsultingConfig");
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
        'day': day,
        'comment': opts['comment'],
        'location': location,
        'from_time': fromTime,
        'to_time': toTime
      };

      var authNames = ['isDoctor'];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = DataResponse;

      return this.apiClient.callApi(
        '/consulting/config', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the signup operation.
     * @callback module:api/DefaultApi~signupCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MessageResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * signup
     * @param {Object} profile Profile object
     * @param {module:api/DefaultApi~signupCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MessageResponse}
     */
    this.signup = function(profile, callback) {
      var postBody = profile;

      // verify the required parameter 'profile' is set
      if (profile === undefined || profile === null) {
        throw new Error("Missing the required parameter 'profile' when calling signup");
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = MessageResponse;

      return this.apiClient.callApi(
        '/signup', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the subscribeForBeta operation.
     * @callback module:api/DefaultApi~subscribeForBetaCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DataResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Endpoint for beta subscription, used on landing page
     * @param {String} email Supplied email address
     * @param {Object} opts Optional parameters
     * @param {String} opts.name Supplied user name address
     * @param {String} opts.phone Supplied phone number
     * @param {String} opts.origin Healthcare field origin of the user
     * @param {module:api/DefaultApi~subscribeForBetaCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DataResponse}
     */
    this.subscribeForBeta = function(email, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'email' is set
      if (email === undefined || email === null) {
        throw new Error("Missing the required parameter 'email' when calling subscribeForBeta");
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
        'email': email,
        'name': opts['name'],
        'phone': opts['phone'],
        'origin': opts['origin']
      };

      var authNames = [];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = DataResponse;

      return this.apiClient.callApi(
        '/public/mail/beta', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the supportEmail operation.
     * @callback module:api/DefaultApi~supportEmailCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MessageResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Support or contact email for us
     * @param {module:model/Params3} params 
     * @param {module:api/DefaultApi~supportEmailCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MessageResponse}
     */
    this.supportEmail = function(params, callback) {
      var postBody = params;

      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling supportEmail");
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = MessageResponse;

      return this.apiClient.callApi(
        '/public/mail/support', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the updateProfile operation.
     * @callback module:api/DefaultApi~updateProfileCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MessageResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Used to upate the profile data (still unfinished)
     * @param {Object} profile Profile object
     * @param {module:api/DefaultApi~updateProfileCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MessageResponse}
     */
    this.updateProfile = function(profile, callback) {
      var postBody = profile;

      // verify the required parameter 'profile' is set
      if (profile === undefined || profile === null) {
        throw new Error("Missing the required parameter 'profile' when calling updateProfile");
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['isLoggedIn'];
      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = MessageResponse;

      return this.apiClient.callApi(
        '/profile', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the uploadAttachment operation.
     * @callback module:api/DefaultApi~uploadAttachmentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse2001} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} statusId ID of a status
     * @param {File} file The uploaded file data
     * @param {module:api/DefaultApi~uploadAttachmentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse2001}
     */
    this.uploadAttachment = function(statusId, file, callback) {
      var postBody = null;

      // verify the required parameter 'statusId' is set
      if (statusId === undefined || statusId === null) {
        throw new Error("Missing the required parameter 'statusId' when calling uploadAttachment");
      }

      // verify the required parameter 'file' is set
      if (file === undefined || file === null) {
        throw new Error("Missing the required parameter 'file' when calling uploadAttachment");
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
        'statusId': statusId,
        'file': file
      };

      var authNames = ['isDoctor'];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = InlineResponse2001;

      return this.apiClient.callApi(
        '/upload/attachment', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the uploadAvatar operation.
     * @callback module:api/DefaultApi~uploadAvatarCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse2001} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {File} file The uploaded file data
     * @param {module:api/DefaultApi~uploadAvatarCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse2001}
     */
    this.uploadAvatar = function(file, callback) {
      var postBody = null;

      // verify the required parameter 'file' is set
      if (file === undefined || file === null) {
        throw new Error("Missing the required parameter 'file' when calling uploadAvatar");
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
        'file': file
      };

      var authNames = ['isValidated'];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = InlineResponse2001;

      return this.apiClient.callApi(
        '/upload/avatar', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));




// WEBPACK FOOTER //
// ./generated/src/api/DefaultApi.js